import Vue from 'vue';
import VueI18n from 'vue-i18n';
import customZhCn from './lang/zh-CN/zh-CN';
import customJaJp from './lang/ja-JP/ja-JP';
import zhCnLocale from 'iview/src/locale/lang/zh-CN';
import jaJpLocale from 'iview/src/locale/lang/ja-JP';

Vue.use(VueI18n);

// 自动根据浏览器系统语言设置语言
//const navLang = navigator.language;
//const localLang = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'ja-JP') ? navLang : false;
//let lang = window.localStorage.lang || localLang || 'zh-CN';
let lang = window.localStorage.lang;
if (!lang) {
    lang = 'ja-JP';
}
//console.log(lang);
Vue.config.lang = lang;
Vue.locale = () => {};

const messages = {
    'zh-CN': Object.assign(zhCnLocale, customZhCn),
    'ja-JP': Object.assign(jaJpLocale, customJaJp),
};

const i18n = new VueI18n({
    locale: lang,
    messages,
});

//将多语言翻译映射到各页面上
Vue.prototype.$_t = function() {
    return Object.assign(this.$t(this.$route.name), this.$t('main'));
};

export default i18n;
